import React from "react";
import Hero from "../components/Hero";
import ConferencesCarousel from "../components/ConferencesCarousel";
import ReviewsSection from "../components/ReviewsSection";

const Home = () => {
  return (
    <div className="home">
      <Hero
        title="Welcome to MUN Society"
        subtitle="Join our journey of diplomacy, debate, and leadership."
        buttonText="Learn More"
        buttonLink="/about"
      />
      <ConferencesCarousel />
      <ReviewsSection /> {/* 🔹 Reviews kısmı korunuyor */}
    </div>
  );
};

export default Home;
